import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';

import { changeListWidth } from '../utils';
import '../style/report.css';
import Refuse from './Refuse.js';
import History from './History.js';

import { apis } from '../api/index.js';
import qs from 'query-string';
import AlertTips from './AlertTips.js';
import { Icon, Breadcrumb, Input, Button, Form } from 'antd';
import { message, Modal, Tabs, Spin, Popover, Radio } from 'antd';
import { eventListener } from '../utils';
import { formatDate, ClearIcon } from '../utils';
import { breadItem, isIncluded } from '../utils';
import { setCountTime } from '../utils';
import OneNameHistory from './OneNameHistory';
import Knowledge from './Knowledge';
import ApplyInfo from './ApplyInfo';
import Score from './Score';
import ReportButtons from './ReportButtons.js';
import _ from 'lodash';

const { TextArea } = Input;
const { TabPane } = Tabs;
const { confirm } = Modal;

const pageIdMap = { 11: '10019', 21: '10020', 26: '10020' };

class Report extends React.Component {
  static propTypes = {
    server: PropTypes.object,
    history: PropTypes.object,
    setApplicationData: PropTypes.func,
    match: PropTypes.object,
    changeMenuTaskData: PropTypes.func,
    user: PropTypes.object,
    form: PropTypes.object,
    reportTime: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      ...qs.parse(window.location.search),
      listWidth: 'calc(87% - 8px)',
      diagId: props.match.params.diagId,
      state: props.match.params.state,
      applicationId: props.match.params.applicationId,
      role: this.props.user.operationAuths.split(','),
      refuseModalShow: false,
      historyModalShow: false,
      tipVisible: false,
      reportInfo: {},
      reasonMessage: '',
      isLoading: false,
      clickedKnowledgeInfo: [],
      operateName: '',
      oneNameList: [],
      dangerChecked: false,
      productionId: '101',
      minTime: 0,
    };
  }

  componentDidMount() {
    this.getReport();
    this.getOneNameDiagList();

    if (this.state.state === '12')
      this.diagnosisRefuseReportReason(this.state.applicationId);
  }

  submitBtnState = () => {
    const { reportInfo } = this.state;
    const { reportTime } = this.props;
    const len = reportInfo.parts.length;
    const { state } = reportInfo;
    let [time1, time2, minTime] = [0, 0, 0];
    if (state === 11) {
      //报告中
      reportTime.forEach(item => {
        if (item.code === 'report_time_min') time1 = parseInt(item.name);
        else if (item.code === 'report_time_q') time2 = parseInt(item.name);
      });
    } else if (state === 21) {
      //审核中（一审）
      reportTime.forEach(item => {
        if (item.code === 'review_time_min') time1 = parseInt(item.name);
        else if (item.code === 'review_time_q') time2 = parseInt(item.name);
      });
    }
    minTime = time1 + time2 * (len - 1);
    const deadline = Date.now() + minTime * 1000;
    this.setState({ deadline, minTime });
  };
  //获取同名人历史信息
  getOneNameDiagList = () => {
    const { diagId } = this.state;
    apis.ctOneNameDiagList(diagId).then(res => {
      if (res.code === '0') this.setState({ oneNameList: res.data });
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  setCountTime = () => {
    const { reportInfo } = this.state;
    const { state, startReportTime, startVerifyTime } = reportInfo;
    let time = '';
    if (state === 11) time = startReportTime;
    else if ([21, 26].includes(state)) time = startVerifyTime;
    const formatDate = setCountTime(time);
    this.countDownFun(formatDate);
  };

  countDownFun = time => {
    let endTime = new Date(time).getTime(),
      sysSecond = endTime - new Date().getTime();
    const { reportInfo } = this.state;
    const _this = this;
    this.timer = setInterval(() => {
      if (!document.getElementById('reportDetail')) {
        clearInterval(this.timer);
      } else {
        //防止倒计时出现负数
        if (sysSecond > 1000) {
          sysSecond -= 1000;
          let minute = Math.floor((sysSecond / 1000 / 60) % 60);
          let second = Math.floor((sysSecond / 1000) % 60);
          this.setState({
            lastTime: minute + '分' + second + '秒',
            endTime,
          });
        } else {
          const { state, reportId, diagId } = reportInfo;
          clearInterval(this.timer);
          this.setState({ lastTime: '0分0秒' });
          let des = '';
          if (state === 11) des = '您花的时间太长了，请问还需要继续填写吗？';
          else if ([21, 26].includes(state))
            des = '您花的时间太长了，请问还需要继续审核吗？';
          confirm({
            title: '提示',
            content: des,
            okText: '继续填写',
            okType: 'danger',
            cancelText: '放弃填写',
            onOk() {
              let url;
              if (state === 11) url = apis.ctContinueReport(diagId);
              else if ([21, 26].includes(state))
                url = apis.ctContinueVerify(reportId);

              _this.setState({ isLoading: true });
              url.then(res => {
                _this.setState({ isLoading: false });
                if (res.code === '0') {
                  message.success('操作成功');
                  if (state === 11) _this.getWriteReport(diagId);
                  else _this.getVerifyReport(diagId);
                } else {
                  message.error(res.message);
                  if (res.code === '1009') _this.props.history.push('/login');
                }
              });
            },
            onCancel() {
              const { state } = reportInfo;
              if ([11, 21, 26].includes(state))
                _this.setState({ isLoading: true });

              if (state === 11) _this.quitReport();
              else if ([21, 26].includes(state)) _this.quitVerify();
            },
          });
        }
      }
    }, 1000);
  };

  back = () => {
    const { reportInfo, productionId, detail } = this.state;
    const { state } = reportInfo;
    let [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-006'];
    if (state === 11) {
      [pageId, moduleId, elementId] = ['10019', 'mk0004', 'ns-005'];
    } else if ([21, 26].includes(state)) {
      [pageId, moduleId, elementId] = ['10020', 'mk0004', 'ns-005'];
    }
    eventListener({ productionId, pageId, moduleId, elementId }, true);

    const stateArray = [40, 26, 21, 11];
    const text = `报告状态最多暂存60分钟，若60分钟内未提交报告，将会清空数据，由其他医生`;
    let des = '';
    if (state === 11) des = text + '填写报告';
    else if ([21, 26].includes(state)) des = text + '审核报告';
    if (
      [11, 26].includes(state) ||
      (state === 21 && !(detail === 'true' && !stateArray.includes(state)))
    ) {
      const _this = this;
      confirm({
        title: '提示',
        content: des,
        okText: '知道了',
        okType: 'danger',
        cancelText: '关闭',
        onOk() {
          clearInterval(_this.timer);
          _this.props.history.go(-1);
        },
      });
    } else this.props.history.go(-1);
  };

  getReport = () => {
    const { diagId, state, applicationId, role, detail } = this.state;
    const stateArray = ['22', '30', '12', '40', '42', '46'];
    const stateArray1 = ['20', '201'];
    const isInArray1 = stateArray1.includes(state);
    const isInArray = stateArray.includes(state);

    const stateArray3 = ['40', '26', '21', '11'];

    //写报告
    const isWrite = ['10', '11'].includes(state);
    //一审
    const isVerify = (isInArray1 && role.includes('T')) || state === '21';
    //二审
    const isVerify2 = role.includes('T2') && state === '26';

    if (detail === 'true' && !stateArray3.includes(state)) {
      this.getReportInfo(applicationId);
    } else if ((isInArray1 && role.includes('M')) || isInArray) {
      this.getReportInfo(applicationId);
    } else if (role.includes('T') && state === '25') {
      this.getReportInfo(applicationId);
    } else if (isWrite) {
      this.getWriteReport(diagId, 'init');
    } else if (isVerify || isVerify2) {
      this.getVerifyReport(diagId, 'init');
    }
  };

  //报告详情
  getReportInfo = async applicationId => {
    apis.ctReportInfo(applicationId).then(res => {
      this.setState({
        reportInfo: res.code === '0' ? res.data : [],
        critical: res.data.critical,
      });
      if ([26, 21, 11].includes(res.data.state)) this.setCountTime();
    });
  };

  //填写报告
  getWriteReport = (diagId, type) => {
    apis.ctWriteReport(diagId).then(res => {
      if (res.code === '0') {
        const { data } = res;
        this.setState(
          { reportInfo: data, dangerChecked: data.critical },
          () => {
            if (type === 'init') this.toViewer();
          }
        );
        this.submitBtnState();
        this.setCountTime();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  //审核报告
  getVerifyReport = (diagId, type) => {
    apis.ctVerifyReport(diagId).then(res => {
      if (res.code === '0') {
        const { data } = res;
        this.setState({
          reportInfo: data,
          dangerChecked: data.critical,
        });
        this.submitBtnState();
        this.setCountTime();
        if (type === 'init') this.toViewer();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  toViewer = (type, record) => {
    let { reportInfo } = this.state;
    reportInfo = type === 'history' ? { ...record } : { ...reportInfo };
    this.props.setApplicationData(reportInfo);

    let url = `/viewer/ct/study/${reportInfo.studyUid}/${reportInfo.diagId}`;
    const [w, h] = [window.screen.width - 10, window.screen.height - 105];
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${w},height=${h}`;
    window.open(url, 'report', str);
  };
  /**
   *
   * @param {1:提交报告;0:暂存报告} flag
   * @param {危急值} dangerValue
   */
  saveReport = (flag, dangerValue) => {
    //flag 1:提交报告 0:暂存报告
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const _this = this;

        const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
        this.props.changeMenuTaskData(time);
        if (flag === 1) {
          this.apiSaveReport(flag, dangerValue, values);
        } else {
          confirm({
            title: '提示',
            content:
              '报告最多暂存60分钟，若60分钟内未提交报告，将会清空数据，由其他医生填写报告',
            okText: '知道了',
            okType: 'danger',
            cancelText: '关闭',
            onOk() {
              _this.apiSaveReport(flag, dangerValue, values);
            },
          });
        }
      }
    });
  };
  setClickedKnowledgeInfo = record => {
    this.setState({ clickedKnowledgeInfo: record });
  };
  /**
   *
   * @param {危急值} dangerValue
   * @param {疑难转诊} needReview2
   * @returns
   * diagnosisGrade诊断报告评分
   * aiFinding AI影像所见
   * radiographyDescription 医生影像所见
   * aiImpression AI诊断建议
   * diagnosisDescription 医生诊断建议
   * kls 点击的知识库列表
   */
  saveReview = (dangerValue, needReview2) => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { reportInfo, dangerChecked } = this.state;
        const { diagId } = reportInfo;
        let post = _.pick(values, [
          'radiographyDescription',
          'diagnosisDescription',
          'diagnosisGrade',
        ]);
        post = {
          ...post,
          diagId,
          critical: dangerValue || dangerChecked,
          kls: this.state.clickedKnowledgeInfo,
        };
        //是否需要二审
        if (needReview2) post.needReview2 = needReview2;

        const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
        this.props.changeMenuTaskData(time);

        apis.ctSaveVerify(post).then(res => {
          if (res.code === '0') {
            message.success('保存成功');
            this.props.history.go(-1);
          } else if (res.code === '1009') this.props.history.push('/login');
        });
      }
    });
  };
  apiSaveReport = (flag, dangerValue, values) => {
    this.setState({ isLoading: true });
    const { diagId, reportInfo, clickedKnowledgeInfo } = this.state;
    const { dangerChecked } = this.state;
    const { radiographyDescription, diagnosisDescription } = values;

    const post = {
      diagId, //必填
      radiographyDescription, //影像所见描述
      diagnosisDescription, //诊断意见
      saveFlag: flag, //必填 0暂存， 1保存nboxReviewDetails
      kls: clickedKnowledgeInfo,
      aiReportId: reportInfo.aiReportId,
      critical: dangerValue || dangerChecked,
    };
    apis.ctSaveReport(post).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('提交成功');
        if (flag === 1) this.props.history.go(-1);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  tsReview = () => {
    const _this = this;
    confirm({
      title: '提示',
      content:
        '审核报告最多暂存60分钟，若60分钟内未提交报告，将会清空数据，由其他医生审核',
      okText: '知道了',
      okType: 'danger',
      cancelText: '关闭',
      onOk() {
        _this.apiTsReview();
      },
    });
  };
  apiTsReview = (dangerValue, needReview2) => {
    let post = this.props.form.getFieldsValue([
      'radiographyDescription',
      'diagnosisDescription',
      'diagnosisGrade',
    ]);

    const { reportInfo, dangerChecked } = this.state;
    const { diagId } = reportInfo;

    post = {
      ...post,
      diagId,
      critical: dangerValue || dangerChecked,
      kls: this.state.clickedKnowledgeInfo,
    };
    //是否需要二审
    if (needReview2) post.needReview2 = needReview2;

    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    this.props.changeMenuTaskData(time);

    apis.ctTempSaveVerify(post).then(res => {
      if (res.code === '0') {
        message.success('暂存成功');
        // this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //放弃填写
  quitReport = () => {
    const { diagId } = this.state.reportInfo;
    apis.ctQuitReport(diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('操作成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //放弃审核
  quitVerify = () => {
    const { diagId } = this.state.reportInfo;
    apis.ctQuitVerify(diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') {
        message.success('操作成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //退回重写
  refuseReView = () => {
    const { diagId } = this.state.reportInfo;
    apis.ctRefuseReView(diagId).then(res => {
      if (res.code === '0') {
        message.success('操作成功');
        this.props.history.go(-1);
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };
  //“拒绝报告”弹出框
  refuseVisible = state => {
    this.setState({ refuseModalShow: state });
  };
  //操作记录弹出框
  historyModalVisible = state => {
    this.setState({ historyModalShow: state });
  };
  //提示信息弹出框
  tipAlertVisible = (state, name) => {
    this.setState({ tipVisible: state, operateName: name });
  };

  //获取拒绝原因
  diagnosisRefuseReportReason = id => {
    apis.ctRefuseReason(id).then(res => {
      if (res.code === '0') this.setState({ reasonMessage: res.data });
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  clearTextarea = type => {
    const { reportInfo, productionId } = this.state;
    const { state } = reportInfo;
    let types;
    const eventData = { productionId };
    let [pageId, moduleId, elementId] = [pageIdMap[state], '', ''];
    if (type === 'radiography') {
      [moduleId, elementId] = ['mk0002', 'ns-002'];
      eventListener({ ...eventData, pageId, moduleId, elementId }, true);

      this.props.form.setFieldsValue({ radiographyDescription: '' });

      types = '1';
    } else if (type === 'diagnosis') {
      [moduleId, elementId] = ['mk0002', 'ns-005'];
      eventListener({ ...eventData, pageId, moduleId, elementId }, true);

      this.props.form.setFieldsValue({ diagnosisDescription: '' });

      types = '2';
    }
    if (typeof reportInfo.aiReportId === 'number') {
      const post = { id: reportInfo.aiReportId, types };
      if (reportInfo.state === 11) post.report = true;
      apis.ctRmAiTxt(post);
    }
    this.setState({ reportInfo });
  };

  dangerOnchange = e => this.setState({ dangerChecked: e.target.checked });

  tabOnChange = activeKey => {
    const { productionId } = this.state;

    if (activeKey === '1') {
      eventListener(
        {
          productionId,
          pageId: '10023',
          moduleId: 'mk0002',
          elementId: 'ns-012',
        },
        true
      );
    } else if (activeKey === '2') {
      eventListener(
        {
          productionId,
          pageId: '10019',
          moduleId: 'mk0003',
          elementId: 'ns-010',
        },
        true
      );
    }
  };

  reportCommentTip = () => {
    return (
      <div className="report-tip-cnt">
        <p>
          <i>严重差错</i>
          --外伤性病变、重大疾病（肿瘤、急危诊）误、漏诊，包括左右定位或部位严重错位；
        </p>
        <p>
          <i>一般性差错</i>
          --主要基本或病变诊断没有误、漏诊，但是次要病变或周围性病变误漏诊，不会造成严重事故或纠纷的差错；
        </p>
        <p>
          <i>用语不当/逻辑差错</i>
          --不遵守影像报告一般规范，报告前后不符合逻辑，报告描述或建议影像影响报告使用人员误解或难理解等等。
        </p>
      </div>
    );
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { reportInfo, role, isLoading } = this.state;
    const { oneNameList, deadline, minTime, listWidth } = this.state;
    const { productionId, detail } = this.state;
    const { state } = reportInfo;
    const leftHeight = parseInt((document.body.clientHeight - 170).toString());

    const disabledArray = [1, 10, 12, 20, 25, 22, 30, 201, 42, 46];
    let inputDisabled = disabledArray.includes(state);

    //报告进行中
    const stateArray = [40, 26, 21, 11];

    //二审医生查看一审中的报告时，不可进行修改
    const isVerify2View =
      state === 21 && role.includes('T2') && !role.includes('T');
    if (detail === 'true' && (!stateArray.includes(state) || isVerify2View))
      inputDisabled = true;

    const isSmall = document.body.clientWidth < 1200;
    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader toggleCollapsed={() => changeListWidth(this)} />
          {isLoading && (
            <div className="spin-box-bg">
              <Spin indicator={<Icon type="loading" spin />} />
            </div>
          )}

          <div className="bread-crumb">
            <Breadcrumb>{breadItem(['诊断报告'])}</Breadcrumb>
            <div className="back" onClick={this.back}>
              &lt;返回
            </div>
          </div>
          <div
            className="box detail-form"
            style={{ width: listWidth }}
            id="reportDetail"
          >
            {/* 如果不是可修改的状态，隐藏左侧知识库 */}
            {!inputDisabled && (
              <Tabs defaultActiveKey="1" onChange={this.tabOnChange}>
                <TabPane tab="知识库" key="1">
                  <Knowledge
                    leftHeight={leftHeight}
                    setClickedKnowledgeInfo={this.setClickedKnowledgeInfo}
                    history={this.props.history}
                    form={this.props.form}
                    state={state || 0}
                  />
                </TabPane>
                {oneNameList.length > 0 && (
                  <TabPane tab="历史报告" key="2">
                    <OneNameHistory
                      leftHeight={leftHeight}
                      oneNameList={oneNameList}
                      toViewer={this.toViewer}
                    />
                  </TabPane>
                )}
              </Tabs>
            )}
            <div className="report-center">
              <ApplyInfo
                reportInfo={reportInfo}
                isSmall={isSmall}
                role={role}
                toViewer={this.toViewer}
                dangerOnchange={this.dangerOnchange}
                dangerChecked={this.state.dangerChecked}
              />
              <Form className="report-cnt">
                <Form.Item
                  label={
                    <div className="report-title">
                      <Icon type="file-text" theme="filled" />
                      影像所见
                      {!inputDisabled && (
                        <Button
                          className="btn-clear btn-right"
                          type="default"
                          size="small"
                          onClick={() => this.clearTextarea('radiography')}
                        >
                          <ClearIcon />
                        </Button>
                      )}
                    </div>
                  }
                  colon={false}
                >
                  {getFieldDecorator('radiographyDescription', {
                    rules: [{ required: true, message: '请输入影像所见' }],
                    initialValue: reportInfo.radiographyDescription,
                  })(
                    <TextArea
                      rows={8}
                      style={{ fontSize: isSmall ? '12px' : '16px' }}
                      disabled={inputDisabled}
                      onBlur={() => {
                        eventListener(
                          {
                            productionId,
                            pageId: pageIdMap[state],
                            moduleId: 'mk0002',
                            elementId: 'ns-001',
                          },
                          true
                        );
                      }}
                    />
                  )}
                </Form.Item>
                <Form.Item
                  label={
                    <div className="report-title">
                      <Icon type="file-text" theme="filled" />
                      诊断建议
                      {!inputDisabled && (
                        <Button
                          className="btn-clear btn-right"
                          type="default"
                          size="small"
                          onClick={() => this.clearTextarea('diagnosis')}
                        >
                          <ClearIcon />
                        </Button>
                      )}
                    </div>
                  }
                  colon={false}
                >
                  {getFieldDecorator('diagnosisDescription', {
                    rules: [{ required: true, message: '请输入诊断建议' }],
                    initialValue: reportInfo.diagnosisDescription,
                  })(
                    <TextArea
                      rows={8}
                      style={{ fontSize: isSmall ? '12px' : '16px' }}
                      disabled={inputDisabled}
                      onBlur={() => {
                        eventListener(
                          {
                            productionId,
                            pageId: pageIdMap[state],
                            moduleId: 'mk0002',
                            elementId: 'ns-004',
                          },
                          true
                        );
                      }}
                    />
                  )}
                </Form.Item>
                <Score report={reportInfo} isSmall={isSmall} role={role} />
                {state === 12 && (
                  <div className="report-doctor">
                    <p>拒绝原因</p>
                    {this.state.reasonMessage}
                  </div>
                )}
                {state >= 21 &&
                  isIncluded(['T', 'M', 'T2'], role) &&
                  state !== 26 && (
                    <Form.Item
                      label={
                        <div className="report-title">
                          报告评价
                          <Popover
                            content={this.reportCommentTip()}
                            placement="topLeft"
                          >
                            <Button type="link" icon="question-circle"></Button>
                          </Popover>
                        </div>
                      }
                      className="comment"
                      colon={false}
                    >
                      {getFieldDecorator('diagnosisGrade', {
                        rules: [{ required: true, message: '请选择报告评价' }],
                        initialValue: reportInfo.diagnosisGrade,
                      })(
                        <Radio.Group
                          className="report-feedback-cnt"
                          disabled={state > 21}
                        >
                          <Radio value={0}>严重差错</Radio>
                          <Radio value={1}>一般性差错</Radio>
                          <Radio value={3}>用语不当/逻辑欠妥</Radio>
                          <Radio value={5}>报告正确完整</Radio>
                        </Radio.Group>
                      )}
                    </Form.Item>
                  )}
                <Form.Item>
                  <ReportButtons
                    reportInfo={reportInfo}
                    saveReport={this.saveReport}
                    role={role}
                    history={this.props.history}
                    tipAlertVisible={this.tipAlertVisible}
                    refuseVisible={this.refuseVisible}
                    historyModalVisible={this.historyModalVisible}
                    changeMenuTaskData={this.props.changeMenuTaskData}
                    getWriteReport={this.getWriteReport}
                    getVerifyReport={this.getVerifyReport}
                    getReportInfo={this.getReportInfo}
                    lastTime={this.state.lastTime}
                    endTime={this.state.endTime}
                    dangerChecked={this.state.dangerChecked}
                    deadline={deadline}
                    minTime={minTime}
                    form={this.props.form}
                    user={this.props.user}
                    tsReview={this.tsReview}
                  />
                </Form.Item>
              </Form>
            </div>
          </div>
          {/* 选择拒绝报告原因 */}
          <Refuse
            visible={this.state.refuseModalShow}
            onCancel={this.refuseVisible}
            reportInfo={reportInfo}
            changeMenuTaskData={this.props.changeMenuTaskData}
            history={this.props.history}
          />
          {/* 提示 */}
          <AlertTips
            visible={this.state.tipVisible}
            operateName={this.state.operateName}
            saveReport={this.saveReport}
            saveReview={this.saveReview}
            quitReport={this.quitReport}
            quitVerify={this.quitVerify}
            refuseReView={this.refuseReView}
            onCancel={this.tipAlertVisible}
          />
          {/* 操作记录 */}
          <History
            visible={this.state.historyModalShow}
            onCancel={this.historyModalVisible}
            reportInfo={reportInfo}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(Report));
